// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import { FormValidator } from '../../../utils/form';
import classNames from 'classnames/bind';
import Checkbox from '../../Checkbox/Checkbox';

import formStyle from '../../../assets/styles/form.scss';
import inputStyle from '../../../assets/styles/input.scss';

type Props = {
  +country: string;
  +isPosting?: boolean;
  +handleSaveAddress: (e: Event) => void;
  +handleChange: (e: SyntheticInputEvent<HTMLInputElement>) => void;
  +handleFocus: (e: Event) => void;
  +name: {
    value: string;
    errors?: string[];
  };
  +saveAddress: boolean;
};

const messages = defineMessages({
  name: {
    label: {
      id: 'preferences.savedAddresses.name.label',
    },
    labelCO: {
      id: 'preferences.savedAddresses.name.label.CO',
    },
    placeholder: {
      id: 'preferences.savedAddresses.name.placeholder',
    },
  },
  zipCode: {
    label: {
      id: 'address.zipCode.label',
    },
    placeholder: {
      id: 'address.zipCode.placeholder',
    },
  },
  transaction: {
    saveAddress: {
      id: 'address.saveAddress',
    }
  }
});

export default class Bottom extends Component<Props> {
  render() {
    const {
      isPosting, handleSaveAddress, handleChange, handleFocus,
      name, saveAddress, country,
    } = this.props;
    const nameError = name.errors && FormValidator.buildErrorLabel(name.errors, {
      required: 'preferences.savedAddresses.name.error.required',
    });
    return (
      <form className={formStyle.formWrap}>
        {country !== 'PE' && <section className={classNames(formStyle.row, formStyle.inputRow,
          formStyle.dualWrap, formStyle.responsiveMedium)}>

          <article className={classNames(formStyle.col)}>
            <FormattedMessage id={country === 'CO' ? messages.name.labelCO.id : messages.name.label.id}>{
              txt => (<label className={formStyle.label}>{txt}:</label>)
            }</FormattedMessage>
            <input disabled={isPosting || !saveAddress}
                   className={classNames(inputStyle.input, { [inputStyle.red]: name.errors && name.errors.length },
                     { [inputStyle.lightBlue]: !!name.value })}
                   value={name.value}
                   onChange={handleChange}
                   onFocus={handleFocus}
                   name="name"
                   placeholder={this.context.intl.formatMessage(messages.name.placeholder)}/>
            {nameError}
          </article>
        </section>}
        <FormattedMessage id={messages.transaction.saveAddress.id}>{
          txt => <Checkbox handleChange={handleSaveAddress}
                           name="saveAddress"
                           value="saveAddress"
                           isChecked={saveAddress}>{txt}
          </Checkbox>
        }</FormattedMessage>
      </form>
    )
  }
}


Bottom.propTypes = {
  country: PropTypes.string.isRequired,
  isPosting: PropTypes.bool,
  handleSaveAddress: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleFocus: PropTypes.func.isRequired,
  name: PropTypes.object.isRequired,
  saveAddress: PropTypes.bool.isRequired,
};

Bottom.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/elements/AddressForm/StandAloneType/Bottom.jsx